import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BaseTableFilteredComponent} from '@ui/filters/base-table-filtered.component';
import {cardS} from '@atmi/core/models';
import {TableContextMenu, TableField, TableSortType, UiTableComponent} from '@ui/table/table';
import {InSubject} from '@atmi/core/utils';
import {BehaviorSubject, combineLatest, firstValueFrom, from, of} from 'rxjs';
import {CardsApiService, filePath, PersonApiService, SwalService} from '@atmi/core';
import {RoleService} from '@sim/role';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Breakpoints} from '@angular/cdk/layout';
import {filter, first, map} from 'rxjs/operators';
import {makeQueryBuilder, makeQueryRules} from '@ui/filters/filters';
import {CardDialogComponent} from '@atmi/shared';
import {CardSFormDialogComponent} from '@atmi/shared/card-s-form-dialog/card-s-form-dialog.component';

@Component({
  selector: 'app-children-s-cards-manager',
  templateUrl: './children-s-cards-manager.component.html',
  styleUrls: ['./children-s-cards-manager.component.scss']
})
export class ChildrenSCardsManagerComponent
  extends BaseTableFilteredComponent<cardS.CardS, cardS.CardSFilter>
  implements UiTableComponent<any> {

  @Input() @InSubject() cardId?: string;
  private readonly cardIdChange = new BehaviorSubject<string | undefined>(undefined);

  @Input() @InSubject() card?: cardS.CardS;
  private readonly cardChange = new BehaviorSubject<cardS.CardS | undefined>(undefined);

  @Output() readonly childAdded = new EventEmitter();

  readonly fields: TableField<any>[] = [
    {
      context: (x) => x.previewUrl ? `${this.fileUrl}${x.previewUrl}` : undefined,
      header: this.translate.instant('Anteprima'),
      key: 'previewUrl',
      template: 'img',
    },
    {
      header: this.translate.instant('Codice unico'),
      key: 'codiceUnico',
      sortable: true,
    },
    {
      header: this.translate.instant('Num. Esemplare'),
      key: 'numeroEsemplare',
    },
    {
      header: this.translate.instant('Tipo figlia'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'tipoOperaFiglia',
      sortable: true,
    },
    {
      context: (x) => x.SGT.SGTT,
      header: this.translate.instant('Titolo soggetto'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'SGT.SGTT',
      sortable: true,
    },
    {
      header: this.translate.instant('Fornitore'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'fornitore$',
      template: 'async',
    },
    {
      align: 'right',
      header: '',
      key: 'context',
      showBreakpoints: [Breakpoints.XSmall, Breakpoints.Small],
      template: 'context',
    },
  ];

  readonly pager$: any = combineLatest([
    this.cardChange.pipe(filter((card): card is cardS.CardS => !!card)),
    this.cardIdChange.pipe(filter((cardId): cardId is string => !!cardId)),
  ]).pipe(
    map(([_, cardId]) => (async (page?: number, limit?: number, sorting?: TableSortType) => {
      const rules = makeQueryRules({benePadre: cardId}, cardS.CardSFiltersMeta);
      const query = makeQueryBuilder(rules);
      const sort: TableSortType = sorting && sorting.length ? sorting : [{field: 'codiceUnico', type: 'asc'}];


      const resultPage = await firstValueFrom(this.cardsApi.indexS({page, limit, filter: query, sort}, 's')
        .pipe(first()));
      const data = resultPage.data.map((d) => (
          {
            ...d,
            // fornitore$: d.fornitore
            //   ? this.personApi.get(d.fornitore).pipe(map((f) => f.ragioneSociale))
            //   : of(undefined),
          }
        )
      );

      return {
        ...resultPage,
        data,
      };
    })),
  );

  readonly contextMenus: Array<TableContextMenu<cardS.CardS>> = [
    {
      action: (item) => this.router.navigate(['cards/s/manager', item.id]),
      label: this.translate.instant('Visualizza'),
    },
  ];

  constructor(@Inject(filePath) private readonly fileUrl: string,
              private readonly cardsApi: CardsApiService,
              private readonly dialog: MatDialog,
              private readonly personApi: PersonApiService,
              private readonly roleService: RoleService,
              protected readonly route: ActivatedRoute,
              protected readonly router: Router,
              protected readonly swalService: SwalService,
              protected readonly translate: TranslateService) {

    super(translate, router, route, cardS.CardSFiltersMeta, swalService, 's/manager', 'local');
    
    // Set default pagination to 50
    this.defaultLimit = 50;
  }

  // ngOnInit(): void {
  // }

  deleteConcreteHandler(id: string) {
    return this.cardsApi.removeS(id);
  }

  deleteSelectedConcreteHandler(ids: string[]) {
    const deleteApis = [new Promise(() => ids.map((id) => firstValueFrom(this.cardsApi.removeS(id))))];

    return from(Promise.all(deleteApis));
  }

  async showAddNewChildrenHandler() {
    if (!this.card) {
      throw new Error('Cannot add a child card without the parent');
    }

    const subsetCard: Partial<cardS.CardS> = {
      AUT: this.card.AUT,
      DES: this.card.DES,
      DT: this.card.DT,
      ESC: this.card.ESC,
      MIS: this.card.MIS,
      MTC: this.card.MTC,
      OGT: this.card.OGT,
      SGT: this.card.SGT,
      TSK: this.card.TSK,
      benePadre: this.cardId,
      codiceUnico: this.card.codiceUnico,
    };

    /*@TODO import proper type for dialog*/
    const ref = this.dialog.open(CardSFormDialogComponent, {data: {cardS: subsetCard}, width: '784px'});
    const res = await firstValueFrom(ref.afterClosed().pipe(first()));

    if (res) {
      this.reload$.next(true);
      this.childAdded.emit();
    }
  }


}
